import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  protected endpoint: string;

  constructor(private apiService: ApiService) {
    this.endpoint = 'rate-manager/provider/configurations';
  }

   private cleanPayload(rawPayload: any) {
    return Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, v]) => v !== null && v !== undefined
      )
    );
  }

  async getConfigurationsByCategoryId(categoryId: number)
  {
    const response: any = await firstValueFrom(
      this.apiService.get(`${this.endpoint}?category_id=${categoryId}`, {}, true)
    );

    return response;
  }

  async saveProviderCategorySettings(payload: Record<string, any>)
  {
    const response: any = await firstValueFrom(this.apiService.post(`${this.endpoint}`, payload));

    return response;
  }
}
